import { Menu } from '@chakra-ui/react';
import React from 'react';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { MenuOption } from 'src/components/atoms/MenuOption';
import { useFilterContext } from 'src/contexts/FilterContext';
import { MenuList } from '../../molecules/MenuList';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { FolderOpen } from 'lucide-react';
import { MenuTriangle } from 'src/components/atoms/MenuTriangle';

const MENU_BUTTON_NAME = 'campaign-group-select';

export const CampaignGroupMenu: React.FC = () => {
  const { campaignGroups, toggleCampaignGroup, toggleAllCampaignGroups } =
    useFilterContext();
  const fontActiveColor = 'content.title';

  const selectedCount = campaignGroups.filter((g) => g.selected).length;

  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton
            buttonName={MENU_BUTTON_NAME}
            textAlign="left"
            color={fontActiveColor}>
            <ChakraIcon
              as={FolderOpen}
              boxSize={5}
              mr={2}
              verticalAlign="middle"
            />
            {selectedCount}/{campaignGroups.length}
            <MenuTriangle isOpen={isOpen} />
          </MenuButton>
          <MenuList
            buttonName={MENU_BUTTON_NAME}
            onAllClick={toggleAllCampaignGroups}>
            {campaignGroups.length === 0 ? (
              <MenuOption
                buttonName={MENU_BUTTON_NAME}
                label="No campaign groups"
                value="empty"
                isSelected={false}
                onClick={() => {}}
              />
            ) : (
              campaignGroups.map((group) => (
                <MenuOption
                  buttonName={MENU_BUTTON_NAME}
                  key={group.id}
                  isSelected={group.selected}
                  label={group.groupName}
                  value={group.id}
                  onClick={() => toggleCampaignGroup(group)}
                />
              ))
            )}
          </MenuList>
        </>
      )}
    </Menu>
  );
};
